import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DataSetsPanel from 'components/DataSetsPanel/DataSetsPanel';
import Select from 'components/Select/Select';
import TextField from 'components/TextField/TextField';
import {
  EU_TAXONOMY_CODE,
  NACE_CODE,
  NACE_SECTION,
} from 'constants/formFields';

import type { ITaxonomyDetailsPanel } from './interfaces/ITaxonomyDetailsPanel';

import stylesCurrency from 'components/FieldWithCurrency/scss/FieldWithCurrency.module.scss';

function TaxonomyDetailsPanel({
  control,
  naceCodesData = [],
  naceDivisions = [],
  onNaceSelectionChange,
  modalRef,
  menuPosition,
}: ITaxonomyDetailsPanel) {
  const { t } = useTranslation();

  return (
    <DataSetsPanel title={t('profitCentres.createProfitCentre.detailsPanel')}>
      <Controller
        control={control}
        name={NACE_SECTION}
        render={({
          field: { value: valueSection, onChange: onChangeSection },
          fieldState: { error: errorSection },
        }) => (
          <Select
            placeholder={t('profitCentres.createProfitCentre.fields.sector')}
            label={t('profitCentres.createProfitCentre.fields.sector')}
            options={naceCodesData}
            value={valueSection?.value ? valueSection : undefined}
            onChange={(newValue) => {
              onChangeSection(newValue);
              onNaceSelectionChange();
            }}
            error={errorSection?.message}
            className={stylesCurrency.select}
            modalRef={modalRef}
            menuPosition={menuPosition}
            required
          />
        )}
      />
      <Controller
        control={control}
        name={NACE_CODE}
        render={({
          field: { value: valueCode, onChange: onChangeCode },
          fieldState: { error: errorCode },
        }) => (
          <Select
            placeholder={t('profitCentres.createProfitCentre.fields.industry')}
            label={t('profitCentres.createProfitCentre.fields.industry')}
            options={naceDivisions}
            value={valueCode && valueCode.value ? valueCode : null}
            onChange={onChangeCode}
            error={errorCode?.message}
            className={stylesCurrency.select}
            modalRef={modalRef}
            menuPosition={menuPosition}
          />
        )}
      />
      <Controller
        control={control}
        name={EU_TAXONOMY_CODE}
        render={({ field: { name, value, onChange }, fieldState: { error } }) => (
          <TextField
            name={name}
            value={value}
            label={t('profitCentres.createProfitCentre.fields.euTaxonomyActivityCode')}
            error={error?.message}
            onChange={(event) => onChange(event.target.value)}
            placeholder={t('profitCentres.createProfitCentre.fields.taxesCode')}
          />
        )}
      />
    </DataSetsPanel>
  );
}

export default TaxonomyDetailsPanel;
